export interface LogIntegracaoGtr {
  CIDRETORNO: string;
  DD3EMISSAO: Date | undefined;
  CDHPROCESSAMENTO: string;
  CD3COD: string;
  CB1DESC: string;
  CD3OP: string;
  CD3LOTESOL: string;
  CMOVIMENTO: string;
  CLOG: string;
  CINTEGRADO: string;
  CDESCRICAORETORNO: string;
}

export const getLogIntegracaoGtrDefault = (): LogIntegracaoGtr => {
  return {
    CIDRETORNO: '',
    DD3EMISSAO: undefined,
    CDHPROCESSAMENTO: '',
    CD3COD: '',
    CB1DESC: '',
    CD3OP: '',
    CD3LOTESOL: '',
    CMOVIMENTO: '',
    CLOG: '',
    CINTEGRADO: '',
    CDESCRICAORETORNO: '',
  };
};

export interface LogIntegracaoGtrLista {
  items: Array<LogIntegracaoGtr>;
}

export const getLogIntegracaoGtrListaDefault = (): LogIntegracaoGtrLista => {
  return {
    items: [],
  };
};
